import { TaskCard, TaskCardProps } from 'components/TaskCard/TaskCard';
import { ReactComponent as MegaphoneIcon } from 'assets/icons/MegaphoneIcon.svg';
import React from 'react';
import { SvgIcon } from 'components/SvgIcon/SvgIcon';
import { useTranslationContext } from 'contexts/TranslationContext/TranslationContext';

interface EncouragementTaskCardProps extends Omit<TaskCardProps, 'taskTypeLabel' | 'icon'> {
  encouragementName: string;
}

export const EncouragementTaskCard = ({
  encouragementName,
  careProgramName,
  isCompleted,
  onClick,
}: EncouragementTaskCardProps) => {
  const { translation } = useTranslationContext();
  const taskTypeLabel = translation('checklist_task_type_encouragement');

  return (
    <TaskCard
      icon={<SvgIcon component={MegaphoneIcon} />}
      taskTypeLabel={taskTypeLabel}
      taskName={encouragementName}
      isCompleted={isCompleted}
      careProgramName={careProgramName}
      onClick={onClick}
    />
  );
};
